import React from 'react'
import { useSelector } from 'react-redux'

export default () => {
  const { appSettings } = useSelector((state) => state.app)

  const {
    theme: {
      images: {
        logo: { src, alt },
      },
    },
  } = appSettings

  return (
    <div id="website-header">
      <div className="logotype">
        <img src={src} alt={__.trans(alt)} />
      </div>
      <a href="https://geblod.nu" className="to-website" tabIndex="0">
        <i className="icon icon-geblod_ikon_pil" />
        <span>{__.trans('login.login-header-link-to-geblod')}</span>
      </a>
    </div>
  )
}
